"use strict";

exports.__esModule = true;
exports.sortTooltipActivities = exports.sortLegendActivities = exports.getActivityKey = exports.getActivityDurationsFromData = exports.formatActivities = void 0;
var _react = _interopRequireDefault(require("react"));
var _StackedBar = require("../../common/AggregateMetricCharts/StackedBar");
var _tooltipSort = require("../../common/tooltipSort");
exports.TOOLTIP_SORT_DESC = _tooltipSort.TOOLTIP_SORT_DESC;
exports.TOOLTIP_SORT_ASC = _tooltipSort.TOOLTIP_SORT_ASC;
exports.TOOLTIP_SORT_ALPHA = _tooltipSort.TOOLTIP_SORT_ALPHA;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getActivityKey = exports.getActivityKey = function getActivityKey(doc) {
  return doc["activity"] + " " + doc["state"];
};
var sortTooltipActivities = exports.sortTooltipActivities = _tooltipSort.sortTooltipItems;
var getActivityDurationsFromData = exports.getActivityDurationsFromData = function getActivityDurationsFromData(data) {
  if (data === void 0) {
    data = [];
  }
  return data.reduce(function (acc, doc) {
    var key = getActivityKey(doc);
    acc[key] = (acc[key] || 0) + (doc.duration_sum || 0);
    return acc;
  }, {});
};
var sortLegendActivities = exports.sortLegendActivities = function sortLegendActivities(activityDetails, data, tooltipSort) {
  if (activityDetails === void 0) {
    activityDetails = [];
  }
  if (data === void 0) {
    data = [];
  }
  if (tooltipSort === void 0) {
    tooltipSort = _tooltipSort.TOOLTIP_SORT_DESC;
  }
  var durations = getActivityDurationsFromData(data);
  return (0, _tooltipSort.sortTooltipItems)(activityDetails.map(function (activity) {
    return Object.assign({}, activity, {
      duration: durations[activity.key] || 0
    });
  }), activityDetails, tooltipSort);
};
var formatActivities = exports.formatActivities = function formatActivities(_ref) {
  var activities = _ref.activities,
    timestamp = _ref.timestamp,
    devices = _ref.devices,
    _ref$totalOfActivitie = _ref.totalOfActivities,
    totalOfActivities = _ref$totalOfActivitie === void 0 ? 0 : _ref$totalOfActivitie,
    _ref$activityDetails = _ref.activityDetails,
    activityDetails = _ref$activityDetails === void 0 ? [] : _ref$activityDetails,
    _ref$tooltipSort = _ref.tooltipSort,
    tooltipSort = _ref$tooltipSort === void 0 ? _tooltipSort.TOOLTIP_SORT_DESC : _ref$tooltipSort;
  if (!totalOfActivities) {
    totalOfActivities = activities.reduce(function (acc, _ref2) {
      var duration = _ref2.duration;
      return acc += duration;
    }, 0) || 1;
  }
  var withPercents = activities.map(function (v) {
    return Object.assign({}, v, {
      value: v.duration * 100 / totalOfActivities
    });
  });
  return {
    key: timestamp,
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_StackedBar.StackedBar, props);
    },
    value: (0, _tooltipSort.sortTooltipItems)(withPercents, activityDetails, tooltipSort),
    devices: devices
  };
};